/**
 * Created by lycheng on 2017/12/4.
 * 浮动导航，默认是右边悬浮，需要改变位置可使用
 * floatMenu.config.position重新赋值
 */

// 右边导航
var floatMenu = {
  config: {
    top: 90,
    $container: $('html,body'),
    checkedClass: 'nav-checked',
    position: {
      top: {
        position: 'absolute',
        top: '600px',
        bottom: 'auto'
      },
      middle: {
        position: 'fixed',
        top: '150px',
        bottom: 'auto'
      },
      bottom: {
        // position: 'fixed',
        // top: '500px',
        // bottom: '0'
      },
      minTop: {
        position: 'fixed',
        top: '550px',
        bottom: 'auto'
      },
      minBottom: {
        position: 'fixed',
        top: '150px',
        bottom: 'auto'
      }
    }
  },
  init: function () {
    floatMenu.bindEvent()
    floatMenu.methods.rePosition()
  },
  bindEvent: function () {
    $('.js-service-nav-fall li').off('click').on('click', function () {
      var target = $(this).attr('target')
      floatMenu.methods.toPosition(target)
    })
    window.onscroll = function () {
      floatMenu.methods.rePosition()
    }
    window.onscroll()
  },
  methods: {
    toPosition: function (target) {
      var top = $('.' + target).offset().top - floatMenu.config.top
      floatMenu.config.$container.animate({scrollTop: Math.floor(top)}, 500)
    },
    rePosition: function () {
      var tops = []
      var top = $('body').scrollTop() || $('html').scrollTop()
      var $navCon = $('.js-service-nav-fall')
      var $navItem = $('.js-service-nav-fall li')
      var targets = []
      var i = 0
      var position = floatMenu.config.position
      $navItem.each(function () {
        targets.push($(this).attr('target'))
      })

      for (i = 0; i < targets.length; i++) {
        tops.push(Math.floor($('.' + targets[i]).offset().top) - floatMenu.config.top)
      }
      tops.push(tops[i - 1] + $('.' + targets[i - 1]).height())

      for (i = 0; i < targets.length; i++) {
        if (top >= tops[i]) {
          $navItem.removeClass(floatMenu.config.checkedClass)
          $navItem.filter('[target="' + targets[i] + '"]').addClass(floatMenu.config.checkedClass)
        }
      }

      if (top >= tops[0]) {
        if ((top + $navCon.height()) + floatMenu.config.top > tops[tops.length - 1]) {
          $navCon.css(position.bottom)
        } else {
          $navCon.css(position.middle)
        }
      } else {
        $navCon.css(position.top)
      }
    }

  }
}
export {
  floatMenu
}



// WEBPACK FOOTER //
// ./src/js/libs/utils-float-menu.js